<p-dialog header="{{dialogTitle}}" [(visible)]="displayDialog" [modal]="true" [style]="{width: '250px', hight:'350px' }"
    [closable]="false" [resizable]="false" [draggable]="false" [dismissableMask]="true">
    <div class="p-fluid">
        <div class="p-d-flex p-jc-between p-ai-center p-mb-3 text-padding">
            <div class="p-field p-mr-2" style="flex: 1;">
                <input pInputText id="from" type="Text" [placeholder]="placeholder" [(ngModel)]="dialogData"
                    [ngModelOptions]="{standalone: true}" >
            </div>
        </div>

        <div class="p-col-12 p-d-flex p-jc-end p-ai-center">
            <button pButton type="button" label="Reset" icon="pi pi-times" class="p-button-secondary p-mr-2"
                (click)="resetFilter()"></button>
            &nbsp;&nbsp;
            <button pButton type="button" label="Apply" icon="pi pi-check" class="p-button-primary"
                (click)="applyFilter()"></button>
        </div>
    </div>
</p-dialog>